module.exports = __webpack_public_path__ + "static/media/mob_alert_partner_silver_x2.67e4d719.png";